// Конец игры наступает, когда завершается указанный раунд
export const FINAL_ROUND = 13;
export const ROUNDS_WITH_RUINS_INCREASED_INCOME = 3;
// Курс обмена монет игроков на очки в конце игры
export const COINS_TO_WIN_POINTS_CONVERSION = 2;

export const STARTING_COINS = 15;
export const STARTING_COINS_DEV_MODE = 100;

export const GAME_END_WIN_POINTS_GAP = 70;